export default __webpack_public_path__ + "static/media/galpao3.cd6ed7d7.jpg";